export enum INLINE_BANNER_CLASSNAME {
  INLINE_HOME_TOP = 'INLINE-HOME-TOP',
  INLINE_HOME_BODY = 'INLINE-HOME-BODY',
  INLINE_PDP_RELATEDPROMO = 'INLINE-PDP-RELATEDPROMO',
  INLINE_PDP_SERVICE = 'INLINE-PDP-SERVICE',
  INLINE_PDP_PREVIEW_DESK = 'INLINE-PDP-PREVIEW-DESK',
  INLINE_PDP_PREVIEW_MOBILE = 'INLINE-PDP-PREVIEW-MOBILE',
  INLINE_SEARCH = 'INLINE-SEARCH',
  INLINE_CATEGORY = 'INLINE-CATEGORY',
  INLINE_BRAND = 'INLINE-BRAND',
  INLINE_SELLER = 'INLINE-SELLER',
  INLINE_CART = 'INLINE-CART',
  INLINE_CHECKOUT = 'INLINE-CHECKOUT',
}
